import { useGetColumnSampleData } from '../api/dataCatalog/getColumnSampleData';
import { Skeleton } from '@mui/material';

export const ColDetailList = ({ columnDetails }) => {
  const colDetails = useGetColumnSampleData({
    tableId:
      columnDetails.sourceId ||
      columnDetails.dDSourceId ||
      columnDetails.tableId,
    columnName: columnDetails.name,
    config: {
      staleTime: Infinity,
    },
  });

  return (
    <div className="flex flex-col w-full">
      {colDetails.isLoading ? (
        Array.from({ length: 10 }).map((_, index) => (
          <div className="flex gap-2 p-2" key={index}>
            <Skeleton
              variant="rounded"
              width={index % 2 === 1 ? '35%' : '65%'}
              height={20}
              sx={{ bgcolor: '#EEF0F7' }}
            />
          </div>
        ))
      ) : colDetails.data?.data?.length > 0 ? (
        <div
          className="flex flex-col w-full border border-pv-neutral-grey-100 rounded-lg overflow-hidden"
          style={{
            maxHeight: '550px',
            overflowY: 'auto',
          }}
        >
          <span className="bg-pv-primary-primary-100 p-2">
            {columnDetails?.name}
          </span>
          {colDetails.data?.data?.map((col, index) => {
            return (
              <span
                className={`p-2 ${index === 0 ? `` : `border-t border-pv-neutral-grey-100`}`}
                key={index}
              >
                {col}
              </span>
            );
          })}
        </div>
      ) : (
        <span className="p-2 w-full text-center">No data available</span>
      )}
    </div>
  );
};
